import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { notifyError, notifySuccess } from "../../../assets/toastService";
import EmailField from "../../components/EmailField";
import CommonButtons from "../../components/CommonButtons";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (value: string, valid: boolean) => {
    setEmail(value);
    setIsValidEmail(valid);
  };

  const getToken = () => {
    return localStorage.getItem("token") || localStorage.getItem("authToken") || localStorage.getItem("access_token");
  };

  const handleSubmit = async () => {
    if (!isValidEmail || loading) return;

    setLoading(true);

    try {
      const token = getToken();

      if (!token) {
        console.warn("No token found in localStorage");
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/forgot-password`,
        { email },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        },
      );

      notifySuccess("Password reset link sent successfully");
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || "Failed to send password reset link";

      if (error.response?.status === 404 && errorMessage === "User not found") {
        notifyError("User not found. Please check the email address and try again.");
      } else {
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex w-screen h-screen bg-[#EEF4F7] justify-center items-center">
      <div className="w-[550px] h-[300px] grid bg-white justify-center items-center rounded-2xl p-6 shadow-md">
        <h1 className="text-2xl font-semibold text-gray-800">Forgot Your Password?</h1>

        <p className="text-gray-600 text-sm text-center">Enter your registered email address to receive a password reset link.</p>

        <EmailField value={email} onChange={handleEmailChange} />

        <div className="mt-4 text-center">
          <CommonButtons className="mx-auto justify-center py-3" label={loading ? "Sending..." : "Send Reset Link"} onClick={handleSubmit} disabled={!isValidEmail || loading} />
        </div>

        <ToastContainer />
      </div>
    </div>
  );
}

export default ForgotPassword;
